import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const concussion: AnswerPathTreeNode = {
  path: 'concussion',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredConcussionDetails }],
};
